/**
Copyright (C) 2022 by SeQuenX  - All Rights Reserved
This file is part of the ComplyVantage product development,
and is released under the "Commercial License Agreement".
You should have received a copy of the Commercial License Agreement license with
this file. If not, please write to: legal@sequenx.com, or visit www.sequenx.com
*/
import React from "react";
import { motion } from "framer-motion";
import AboutUsImg from "../assets/svg/about-us.svg";
import { useTranslation } from "react-i18next";

const AboutUsDetails = () => {
  const { t } = useTranslation();
  const aboutUsDescription = t("aboutUs.description", { returnObjects: true });

  return (
    <section className="py-20">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h1 className="text-4xl font-bold text-gray-800 mb-4 ">
            {t("aboutUs.title")}
          </h1>
          <div className="w-24 h-1 bg-blue-600 mx-auto"></div>
        </motion.div>

        <div className="flex flex-col md:flex-row items-center gap-12">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true }}
            className="w-full md:w-1/2"
          >
            <img
              src={AboutUsImg}
              alt="About us"
              className="w-full max-w-lg mx-auto rounded-lg shadow-xl transform hover:scale-105 transition-transform duration-300"
            />
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6, delay: 0.3 }}
            viewport={{ once: true }}
            className="w-full md:w-1/2 space-y-6"
          >
            <div className="prose prose-lg">
              <p className="text-gray-700 leading-relaxed">
                {aboutUsDescription[0]}
              </p>
              <p className="text-gray-700 leading-relaxed">
                {aboutUsDescription[1]}
              </p>
            </div>
          </motion.div>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.4 }}
          viewport={{ once: true }}
          className="mt-20"
        >
          <div className="bg-white rounded-xl shadow-lg p-8">
            <div className="prose prose-lg max-w-none">
              <p className="text-gray-700 leading-relaxed">
                {aboutUsDescription[2]}
              </p>
              <p className="text-gray-700 leading-relaxed">
                {aboutUsDescription[3]}
              </p>
              <p className="text-gray-700 leading-relaxed">
                {aboutUsDescription[4]}{" "}
                <a
                  href="https://www.normeringarbeid.nl/snakeurmerk/gecertificeerde-ondernemingen?q=SeQuenX&filters%5Bsector%5D=&filters%5Bkvk%5D=&filters%5Bnormen%5D="
                  rel="noopener noreferrer"
                  target="_blank"
                  className="text-blue-600 hover:text-blue-800 transition-colors duration-300"
                >
                  {aboutUsDescription[5]}
                </a>{" "}
                {aboutUsDescription[6]}{" "}
                <a
                  href="https://ind.nl/en/search?s=SeQuenX"
                  rel="noopener noreferrer"
                  target="_blank"
                  className="text-blue-600 hover:text-blue-800 transition-colors duration-300"
                >
                  {aboutUsDescription[7]}
                </a>{" "}
                {aboutUsDescription[8]}
              </p>
              <p className="text-gray-700 leading-relaxed">
                {aboutUsDescription[9]}{" "}
                <a
                  href="https://www.openchainproject.org/featured/2021/01/13/sequenx-is-the-latest-openchain-partner"
                  rel="noopener noreferrer"
                  target="_blank"
                  className="text-blue-600 hover:text-blue-800 transition-colors duration-300"
                >
                  {aboutUsDescription[10]}
                </a>
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default AboutUsDetails;
